// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Admin } from './admin';
import { AppointeeAppointment } from './appointee-appointment';
import { Batch } from './batch';
import { Bond } from './bond';
import { Contribution } from './contribution';
import { Dividend } from './dividend';
import { Document } from './document';
import { Insurer } from './insurer';
import { Lodgement } from './lodgement';
import { Practice } from './practice';
import { Reconciliation } from './reconciliation';
import { UserAdminRole } from './user-admin-role';
import { UserManager } from './user-manager';
import { UserNumber } from './user-number';
import { UserSetting } from './user-setting';
import { UserType } from './user-type';
import { iTask } from './i-task';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class User extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  /** Initials - but Reference1 may also contain initials */
  get initials(): string {
    return (this.firstName ? this.firstName.charAt(0) : '') + (this.lastName ? this.lastName.charAt(0) : '');
  }
  /// </code>

  // Generated code. Do not place code below this line.
  userId!: number;
  agentNo?: string;
  authorisingBodyLookupId?: number;
  correspondenceName?: string;
  createdBy!: string;
  createdDate!: Date;
  firstName?: string;
  gender?: string;
  hasNewTask!: boolean;
  insurerId?: number;
  insurerRef?: string;
  isCorporateAppointee!: boolean;
  isInactive!: boolean;
  isPersonalAppointee!: boolean;
  lastName?: string;
  logonName!: string;
  name!: string;
  password?: string;
  practiceId?: number;
  reference1?: string;
  reference2?: string;
  reportingPracticeId?: number;
  supervisorUserId?: number;
  title?: string;
  ts!: string;
  uid!: string;
  updatedBy!: string;
  updatedDate!: Date;
  userTypeId!: number;
  webFlags?: number;
  adminReportingUserId1Navigations!: Admin[];
  adminReportingUsers!: Admin[];
  appointeeAppointments!: AppointeeAppointment[];
  appointees!: UserManager[];
  batchAuthorisedByUsers!: Batch[];
  batchPostedByUsers!: Batch[];
  batchPreparedByUsers!: Batch[];
  bonds!: Bond[];
  contributionFollowUpUsers!: Contribution[];
  contributionNoticeUsers!: Contribution[];
  dividends!: Dividend[];
  documentAuthorisedByUsers!: Document[];
  documentSentByUsers!: Document[];
  documentUsers!: Document[];
  insurer!: Insurer;
  inverseSupervisorUser!: User[];
  lodgements!: Lodgement[];
  managers!: UserManager[];
  practice!: Practice;
  reconciliations!: Reconciliation[];
  reportingPractice!: Practice;
  supervisorUser!: User;
  tasks!: iTask[];
  userAdminRoles!: UserAdminRole[];
  userManagers!: UserManager[];
  userNumbers!: UserNumber[];
  userSettings!: UserSetting[];
  userType!: UserType;
}

